import gsap from "gsap";

export default function Stepsslider() {
  Alpine.data("stepsslider", () => ({
    current: 0,
    total: 0,

    init() {
      this.total = parseInt(this.$el.dataset.total) || 0;

      if (this.$refs.media) {
        gsap.fromTo(
          this.$refs.media,
          {
            scale: 1.1,
          },
          {
            scale: 1,
            ease: "none",
            scrollTrigger: {
              trigger: this.$el,
              start: "top bottom",
              end: "top top",
              scrub: true,
            },
          },
        );
      }
    },

    prev() {
      if (this.current > 0) this.current--;
    },

    next() {
      if (this.current < this.total - 1) this.current++;
    },

    goTo(index) {
      this.current = index;
    },
  }));
}
